<template>
  <section class="chrome-card" :class="{ 'chrome-card--wide': wide }" aria-labelledby="chrome-card-title">
    <span class="chrome-card-icon" aria-hidden="true"><ph-icon name="google-chrome-logo" :size="32" /></span>
    <div class="chrome-card-text">
      <h2 id="chrome-card-title" class="chrome-card-title">Score forms while you browse</h2>
      <p>
        The Exatom Chrome extension runs the same checks on any page you open, including forms behind a login or deep in a checkout.
        Share the results with your team in one click.
      </p>
    </div>
    <a :href="extensionUrl" target="_blank" rel="noopener" class="ex-btn ex-btn--dark">
      <ph-icon name="google-chrome-logo" :size="18" />
      <span class="ex-btn__label" data-label="Add to Chrome">Add to Chrome</span>
    </a>
  </section>
</template>

<script>
import PhIcon from './PhIcon.vue'
import { CHROME_EXTENSION_URL } from '../score/links'

export default {
  name: 'ChromeExtensionCard',
  components: { PhIcon },
  props: {
    // A full-width band on the home page; a card next to the free plan on the result pages.
    wide: { type: Boolean, default: false }
  },
  data () {
    return { extensionUrl: CHROME_EXTENSION_URL }
  }
}
</script>

<style scoped>
.chrome-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  height: 100%;
  padding: 28px 32px;
  border-radius: var(--ex-radius-panel);
  background: var(--ex-color-blue-light);
}

.chrome-card--wide {
  flex-direction: row;
  align-items: center;
  gap: 28px;
  padding: 40px 48px;
}

.chrome-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  flex: none;
  border-radius: var(--ex-radius-panel);
  background: var(--ex-color-white);
  color: var(--ex-color-blue);
}

.chrome-card-text {
  flex: 1;
}

.chrome-card-title {
  font-size: 22px;
  letter-spacing: -0.02em;
}

.chrome-card--wide .chrome-card-title {
  font-size: 28px;
}

.chrome-card-text p {
  margin-top: 6px;
  font-size: 15px;
  line-height: 1.5;
  color: var(--ex-color-neutral-700);
}

@media (max-width: 960px) {
  .chrome-card--wide {
    flex-direction: column;
    align-items: flex-start;
    padding: 28px 24px;
  }
}
</style>
